import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type PageDescriptionProps = {
  children: ReactNode;
  className?: string;
};

export function PageDescription({ children, className }: PageDescriptionProps) {
  return (
    <p
      className={cn(
        'mt-2 text-sm text-muted-foreground max-w-[75ch]',
        className,
      )}
    >
      {children}
    </p>
  );
}
